enum DiscountImageTypes {
  banner = 1,
}

export default DiscountImageTypes;
